/**
 * The feed posts a learner has heard to the end (owner rule 2026-10-14,
 * «تا آخر پخش کرده»): clap and rate open only then. Kept on this device per
 * learner, so a reload or a second visit does not ask them to listen again;
 * the server keeps its own record of who fetched which recording and refuses
 * a reaction that comes too soon (`listen_first`).
 */

/** The newest this many posts are kept; the feed is a day's posts, far fewer. */
export const HEARD_CAP = 500

const keyOf = (userId) => `tooti.heard.${userId}`

function storageOf(storage) {
  if (storage !== undefined) return storage
  try {
    return globalThis.localStorage ?? null
  } catch {
    return null
  }
}

/** The post ids this learner has heard to the end — empty without a learner or storage. */
export function readHeard(userId, storage) {
  const store = storageOf(storage)
  if (!userId || !store) return new Set()
  try {
    const ids = JSON.parse(store.getItem(keyOf(userId)) ?? '[]')
    return new Set(Array.isArray(ids) ? ids.filter((id) => typeof id === 'string') : [])
  } catch {
    return new Set()
  }
}

/** Remember that `postId` played to the end; answers the new set. Storage that refuses is not an error. */
export function rememberHeard(userId, postId, storage) {
  const heard = readHeard(userId, storage)
  if (!userId || !postId || heard.has(postId)) return heard
  const next = [...heard, postId].slice(-HEARD_CAP)
  const store = storageOf(storage)
  try {
    store?.setItem(keyOf(userId), JSON.stringify(next))
  } catch {
    // Private window or full storage: heard for this visit only.
  }
  return new Set(next)
}
